import { render, staticRenderFns } from "./certificateBindDetailView.vue?vue&type=template&id=52f16099&"
import script from "./certificateBindDetailView.vue?vue&type=script&lang=js&"
export * from "./certificateBindDetailView.vue?vue&type=script&lang=js&"
import style0 from "./certificateBindDetailView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports